<template>
  <el-card>
    <section>
      <el-row>
        <el-col :span="24">
          <el-card class="box-card">
            <el-form label-width="150px" size="small" >
              <el-form-item label="旧密码">
                <el-input type="password" v-model="passwordForm.password" placeholder="请输入旧密码"></el-input>
              </el-form-item>
              <el-form-item label="新密码">
                <el-input type="password" v-model="passwordForm.newPass1" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="再次确认新密码">
                <el-input type="password" v-model="passwordForm.newPass2" placeholder="请输入确认密码"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button  size="small" type="primary" @click="changePassword">确认</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>
      </el-row>

    </section>
  </el-card>
</template>

<script>
/* eslint-disable */
import { doPost } from '../../api/api'

export default {
  data () {
    return {
      passwordForm: {
        id: '',
        password: '',
        newPass1: '',
        newPass2: ''
      },
      user: {}
    }
  },
  methods: {
    changePassword () {
      if (this.passwordForm.password === null || this.passwordForm.password === '') {
        this.$message({
          message: '旧密码不能为空',
          type: 'error'
        })
        return
      }
      if (this.passwordForm.newPass1 === null || this.passwordForm.newPass1 === '') {
        this.$message({
          message: '新密码不能为空',
          type: 'error'
        })
        return
      } else if (this.passwordForm.newPass1.length < 6) {
        this.$message({
          message: '新密码长度不能少于6位!',
          type: 'error'
        })
        return
      }

      if (this.passwordForm.newPass2 === null || this.passwordForm.newPass2 === '') {
        this.$message({
          message: '再次确认新密码不能为空',
          type: 'error'
        })
        return
      }
      if (this.passwordForm.newPass1 !== this.passwordForm.newPass2) {
        this.$message({
          message: '新密码不一致',
          type: 'error'
        })
        return
      }
      doPost('/sysUser/updatePassWord', this.passwordForm).then(res => {
        if (res.code === 0) {
          // 修改成功  提示信息
          if (res.result === true || res.result === 'true') {
            this.$message({
              message: '密码修改成功!',
              type: 'success'
            })
          } else {
            this.$message({
              message: '密码修改失败，旧密码错误!',
              type: 'success'
            })
          }

          // 跳转回首页
          //          this.$router.push('/login')
        } else {
          // 登录失败 提示信息
          this.$message({
            message: res.result,
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.passwordForm.id = this.user.id
  }
}

</script>

<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .form-line {
    display: flex;
    overflow: hidden;
  }
</style>
